import axios, { AxiosResponse } from "axios";
import { Config } from "../config";
import { StoreResponse } from "@/interfaces/store/store";

interface ApiResponse {
  data: {
    data: string[]
  };
}

export const GetStoreInfo = async (storeId: string, token: string) => {
  try {
    const data = await axios({
      method: "get",

      url: Config.apiEndpoint + `store/${storeId}/get-store-info`,
      headers: {
        "accept-language": "th",
        "Authorization": "Basic " + Config.encoded,
        "x-access-token": token,
        "Content-Type": "application/json",
      },
    });
    return data.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      error = error.response;
      return error;
    }
  }
};

export const StoreInfo = async (storeId: string, token: string) => {
  try {
    const data = await axios({
      method: "get",
      // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
      url: Config.apiEndpoint + `store/${storeId}/get-store-info`,
      headers: {
        "accept-language": "th",
        "Authorization": "Basic " + Config.encoded,
        "x-access-token": token,
        "Content-Type": "application/json",
      },
    });
    return data.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      error = error.response;
      return error;
    }
  }
};


export const FavoriteButton = async (storeId: string, token: string) => {
  try {
    const data = await axios<ApiResponse>({
      method: "put",
      maxBodyLength: Infinity,
      url: Config.apiEndpoint + `store/${storeId}/follow`,
      headers: {
        "accept-language": "th",
        "Authorization": "Basic " + Config.encoded,
        "x-access-token": token,
        "Content-Type": "application/json",
      },
    });
    return data.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      error = error.response;
      return error;
    }
  }
};



export const Follow = async (storeId: string, token: string) => {
  try {
    const data = await axios<ApiResponse>({
      method: "put",
      maxBodyLength: Infinity,
      url: Config.apiEndpoint + `store/${storeId}/follow`,
      headers: {
        "accept-language": "th",
        "Authorization": "Basic " + Config.encoded,
        "x-access-token": token,
        "Content-Type": "application/json",
      },
    });
    return data.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      error = error.response;
      return error;
    }
  }
};


export const UnFollow = async (storeId: string, token: string) => {
  try {
    const data = await axios<ApiResponse>({
      method: "put",
      maxBodyLength: Infinity,
      url: Config.apiEndpoint + `store/${storeId}/unfollow`,
      headers: {
        "accept-language": "th",
        "Authorization": "Basic " + Config.encoded,
        "x-access-token": token,
        "Content-Type": "application/json",
      },
    });
    return data.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      error = error.response;
      return error;
    }
  }
};

export const UnFavoriteButton = async (storeId: string, token: string) => {
  try {
    const data = await axios<ApiResponse>({
      method: "put",
      maxBodyLength: Infinity,
      url: Config.apiEndpoint + `store/${storeId}/unfollow`,
      headers: {
        "accept-language": "th",
        "Authorization": "Basic " + Config.encoded,
        "x-access-token": token,
        "Content-Type": "application/json",
      },
    });
    return data.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      error = error.response;
      return error;
    }
  }
};


export const StoreFollow = async (token: string, idStore: string) => {
  try {
    const data = await axios<ApiResponse>({
      method: "put",
      // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
      url: Config.apiEndpoint + `store/${idStore}/follow`,
      headers: {
        "accept-language": "th",
        "Authorization": "Basic " + Config.encoded,
        "x-access-token": token,
        "Content-Type": "application/json",
      },
      // data: JSON.stringify(props)
    });
    return data.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      error = error.response;
      return error;
    }
  }
};

export const StoreUnfollow = async (token: string, idStore: string) => {
  try {
    const data = await axios<ApiResponse>({
      method: "put",
      // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
      url: Config.apiEndpoint + `store/${idStore}/unfollow`,
      headers: {
        "accept-language": "th",
        "Authorization": "Basic " + Config.encoded,
        "x-access-token": token,
        "Content-Type": "application/json",
      },
      // data: JSON.stringify(props)
    });
    return data.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      error = error.response;
      return error;
    }
  }
};

export const ProductStoreCategory = async (token: string, idStore: string, productType: string) => {
  try {
    const data = await axios({
      method: "get",
      // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
      url: Config.apiEndpoint + `product/${idStore}/get-product-store-category?product_type=${productType}`,
      headers: {
        "accept-language": "th",
        "Authorization": "Basic " + Config.encoded,
        "x-access-token": token,
        "Content-Type": "application/json",
      },
    });
    return data.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      error = error.response;
      return error;
    }
  }
};


export const ProductHomeBestSeller = async (limit: string, token: string) => {
  try {
    const data = await axios<ApiResponse>({
      method: "get",
      maxBodyLength: Infinity,
      url:
        // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
        Config.apiEndpoint +
        `product/get-product-home-best-seller/?limit=${limit}`,
      headers: {
        "accept-language": "th",
        "Authorization": "Basic " + Config.encoded,
        "x-access-token": token,
        "Content-Type": "application/json",
      },
    });
    return data.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      error = error.response;
      return error;
    }
  }
};

export const StoreInSearch = async (token: string) => {
  try {
    const data = await axios<ApiResponse>({
      method: "get",
      // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
      url: Config.apiEndpoint + `store/get-relevant-store-in-search`,
      headers: {
        "accept-language": "th",
        "Authorization": "Basic " + Config.encoded,
        "x-access-token": token,
      },
    });
    return data.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      error = error.response;
      return error;
    }
  }
};


export const ProducStoreBestSell = async (limit: string, token: string) => {
  try {
    const data = await axios<ApiResponse>({
      method: "get",
      maxBodyLength: Infinity,
      // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
      url: Config.apiEndpoint + `product/get-product-home-best-seller?limit=${limit}`,
      headers: {
        "accept-language": "th",
        "Authorization": "Basic " + Config.encoded,
        "x-access-token": token,
        "Content-Type": "application/json",
      },
    });
    return data.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      error = error.response;
      return error;
    }
  }
};

export const GetStoreReview = async (storeId: string, token: string) => {
  try {
    const data = await axios({
      method: "get",
      maxBodyLength: Infinity,
      url: Config.apiEndpoint + `store/${storeId}/get-store-review`,
      headers: {
        "accept-language": "th",
        "Authorization": "Basic " + Config.encoded,
        "x-access-token": token,
        "Content-Type": "application/json",
      },
    });
    return data.data;
  } catch (error) {
    // if (axios.isAxiosError(error) && error.response) {
    //   error = error.response;
    //   return error;
    // }
  }
};


export const GetStoreCateAddOn = async (storeId: string, token: string) => {
  try {
    const data = await axios({
      method: "get",
      maxBodyLength: Infinity,
      url: Config.apiEndpoint + `store/${storeId}/get-store-category-addon`,
      headers: {
        "accept-language": "th",
        "Authorization": "Basic " + Config.encoded,
        "x-access-token": token,
        "Content-Type": "application/json",
      },
    });
    return data.data;
  } catch (error) {
    // if (axios.isAxiosError(error) && error.response) {
    //   error = error.response;
    //   return error;
    // }
  }
};


export const GetProductStoreCategoryAddon = async (storeId: string, categoryId: string, productType: string) => {
  try {
    const data = await axios({
      method: "get",
      maxBodyLength: Infinity,
      url: Config.apiEndpoint + `product/get-product-store-category-addon?store_id=${storeId}&category_id=${categoryId}&product_type=${productType}`,
      headers: {
        "accept-language": "th",
        "Authorization": "Basic " + Config.encoded,
        "Content-Type": "application/json",
      },
    });
    return data.data;
  } catch (error) {
    // if (axios.isAxiosError(error) && error.response) {
    //   error = error.response;
    //   return error;
    // }
  }
}


export const GetReportCategory = async (token: string, productType: string) => {
  try {
    const data = await axios<ApiResponse>({
      method: "get",
      // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
      url: Config.apiEndpoint + `report/get-report-category?report_type=${productType}`,
      headers: {
        "accept-language": "th",
        "Authorization": "Basic " + Config.encoded,
        "x-access-token": token,
      },
    });
    return data.data;
  } catch (error) {
    // if (axios.isAxiosError(error) && error.response) {
    //   error = error.response;
    //   return error;
    // } 
  }
};


export const GetStoreActive = async (token: string, storeID: string) => {
  try {
    const data = await axios<ApiResponse>({
      method: "get",
      // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
      url: Config.apiEndpoint + `store/get-store-active?store_id=${storeID}`,
      headers: {
        "accept-language": "th",
        "Authorization": "Basic " + Config.encoded,
        "x-access-token": token,
      },
    });
    return data.data;
  } catch (error) {
    // if (axios.isAxiosError(error) && error.response) {
    //   error = error.response;
    //   return error;
    // } 
  }
};



export const GetStoreSearch = async (keyword: string, limit: number, offset: number): Promise<StoreResponse | any> => {
  try {
    const response = await axios<StoreResponse>({
      method: "get",
      url: `${Config.apiEndpoint}store/get-store-search?keyword=${keyword}&limit=${limit}&offset=${offset}`,
      headers: {
        "accept-language": "th",
        "Authorization": `Basic ${Config.encoded}`,
      },
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error;
    }
    return error;
  }
};

export const GetProductsInStore = async (storeId: string, limit: number, productType: string) => {
  try {
    const response: AxiosResponse = await axios({
      maxBodyLength: Infinity,
      url: `${Config.apiEndpoint}product/get-products?store_id=${storeId}&order=id&product_type=${productType}&rank=DESC&limit=${limit}&offset=0`,
      headers: {
        "accept-language": "th",
        "Authorization": "Basic " + Config.encoded,
        "Content-Type": "application/json",
      },
      method: 'get'
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      return error.response;
    } else {
      throw error;
    }
  }
};

export const GetProductsRecommend = async (storeId: string, limit: number, productType: string) => {
  try {
    const response: AxiosResponse = await axios({
      maxBodyLength: Infinity,
      url: `${Config.apiEndpoint}product/get-products?store_id=${storeId}&order=id&product_type=${productType}&rank=DESC&limit=${limit}&offset=0&recommend=true`,
      headers: {
        "accept-language": "th",
        "Authorization": "Basic " + Config.encoded,
        "Content-Type": "application/json",
      },
      method: 'get'
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      return error.response;
    } else {
      throw error;
    }
  }
};






